import { render, staticRenderFns } from "./LibroPreek.vue?vue&type=template&id=121c520e"
import script from "./LibroPreek.vue?vue&type=script&lang=js"
export * from "./LibroPreek.vue?vue&type=script&lang=js"
import style0 from "./LibroPreek.vue?vue&type=style&index=0&id=121c520e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports